import { css } from "@emotion/css";
import { Colors } from "@snapchat/snap-design-system";
// https://github.sc-corp.net/Snapchat/snap-design-system/blob/c12dfccb6f59dd79a933f18060419629fdd95ddb/packages/snap-design-system/src/components/Button/BaseButton.scss#L76

export const buttonDisabled = css`
    &.sds-button.ant-btn.primary,
    &.sds-button.ant-btn.default,
    &.sds-button.sds-base-button.regular {
        pointer-events: none;
        cursor: not-allowed;

        color: ${Colors.Black.V50};

        background: ${Colors.Gray.V150}
            repeating-linear-gradient(
                45deg,
                ${Colors.Gray.V200},
                ${Colors.Gray.V200} 1px,
                ${Colors.Gray.V150} 1px,
                ${Colors.Gray.V150} 5px
            );
        box-shadow: 0 0 0 1px ${Colors.Gray.V200};

        &:hover,
        &:active,
        &:focus {
            color: ${Colors.Black.V50};
            background: ${Colors.Gray.V150}
                repeating-linear-gradient(
                    45deg,
                    ${Colors.Gray.V200},
                    ${Colors.Gray.V200} 1px,
                    ${Colors.Gray.V150} 1px,
                    ${Colors.Gray.V150} 5px
                );
            box-shadow: 0 0 0 1px ${Colors.Gray.V200};
        }
    }
`;
